import React from 'react';
import {Card, CardBody,} from 'reactstrap';
import {rolePermissionService} from "../../../jwt/_services";
import {confirmAlert} from "react-confirm-alert";
import {ActiveFormatter} from "../../../components/tables/activeFormater";
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import {ButtonTableDelete} from "../../../components/buttons/buttonsActions";
import {ARE_YOU_SHURE_MSG, ARE_YOU_SHURE_TITLE, NO, YES} from "../../../components/i18n/i18n";
import {showLoader} from "../../../components/loader/loader";

class RolePermissionList extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            error: '',
            page: 0,
            sizePerPage: 10,
            totalSize: 10,
            role: this.props.role,
            loading: false,
            listItems: []
        };

        this.actionsFormatter = this.actionsFormatter.bind(this);
        this.activeFormatter = this.activeFormatter.bind(this);
        this.refreshList = this.refreshList.bind(this);
    }

    componentDidMount() {
        this.getDataList();
    }

    handleTableChange = (type, {page, sizePerPage, filters, sortField}) => {
        this.getDataList();
    }

    getDataList() {
        const data = {
            role: this.props.role
        }
        this.setState({loading: true});
        let filteredItems = [];

        rolePermissionService.search(data)
            .then(result => {
                if (result) {
                    result.map((rolePerm) => {

                        const newItem = {
                            id: rolePerm.id,
                            role: rolePerm.role?.name,
                            udn: rolePerm.udn?.name,
                            module: rolePerm.module?.name,
                            menu: rolePerm.menu?.name,
                            allowSearch: rolePerm.allowSearch,
                            allowEdit: rolePerm.allowEdit,
                            allowDelete: rolePerm.allowDelete,
                            allowAdd: rolePerm.allowAdd,
                            allowGallery: rolePerm.allowGallery,
                            allowSchedule: rolePerm.allowSchedule,
                            allowSync: rolePerm.allowSync,
                            allowPrices: rolePerm.allowPrices,

                        };

                        filteredItems.push(newItem);
                    });
                    this.setState({listItems : filteredItems, loading : false});
                } else {
                    this.setState({loading: false});
                }
            })
            .catch(
                error =>
                    this.setState({
                        error: error.message,
                        loading: false
                    }));
    }

    confirmDelete = (data) => {
        return confirmAlert({
            closeOnEscape: true,
            closeOnClickOutside: true,
            customUI: ({onClose}) => {
                return (
                    <div className='custom-ui'>
                        <h1>{ARE_YOU_SHURE_TITLE}</h1>
                        <p>{ARE_YOU_SHURE_MSG}</p>
                        <button onClick={onClose}>{NO}</button>
                        <button className={"btn-alert-delete"} onClick={() => {
                            this.deleteItem(data)
                            onClose();
                        }}>
                            {YES}
                        </button>
                    </div>
                );
            }
        });
    };

    deleteItem = (data) => {
        this.setState({loading: true});

        rolePermissionService.deleteItem(data.id)
            .then(() => {
                this.getDataList();
                this.setState({
                    loading: false
                })
            })
            .catch(
                error =>
                    this.setState({
                        error: error.message,
                        loading: false
                    }));
    }

    async refreshList() {
        await this.getDataList();
    }

    activeFormatter(cell) {
        return (
            <ActiveFormatter active={cell}/>
        );
    }

    actionsFormatter(cell, row) {
        return (
            <div className="float-right">
                <ButtonTableDelete onClick={() => this.confirmDelete(row)}/>
            </div>
        );
    }

    render() {
        const {listItems, sizePerPage, page, totalSize} = this.state;

        const columns = [{
            dataField: 'id',
            headerStyle: {width: '0px'},
            text: 'ID',
            hidden: true
        }, {
            dataField: 'module',
            text: 'Modulo',
            headerStyle: {width: '100px'},
            sort: true
        }, {
            dataField: 'allowSearch',
            headerStyle: {width: '40px'},
            text: 'Buscar',
            formatter: this.activeFormatter
        }, {
            dataField: 'allowAdd',
            headerStyle: {width: '40px'},
            text: 'Agregar',
            formatter: this.activeFormatter
        }, {
            dataField: 'allowEdit',
            headerStyle: {width: '40px'},
            text: 'Editar',
            formatter: this.activeFormatter
        }, {
            dataField: 'allowDelete',
            headerStyle: {width: '40px'},
            text: 'Borrar',
            formatter: this.activeFormatter
        }, {
            dataField: 'allowGallery',
            headerStyle: {width: '40px'},
            text: 'Galeria',
            formatter: this.activeFormatter
        }, {
            dataField: 'allowSchedule',
            headerStyle: {width: '40px'},
            text: 'Horarios',
            formatter: this.activeFormatter
        }, {
            dataField: 'allowSync',
            headerStyle: {width: '40px'},
            text: 'Upd. Firebase',
            formatter: this.activeFormatter
        }, {
            dataField: 'allowPrices',
            headerStyle: {width: '40px'},
            text: 'Upd. Precios',
            formatter: this.activeFormatter
        }, {
            isDummyField: true,
            text: 'Acción',
            headerStyle: {width: '40px'},
            formatter: this.actionsFormatter
        }
        ];

        return (
            <div>
                {this.state.loading ? showLoader() : null}
                <Card>
                    <CardBody className="">
                            <BootstrapTable
                                striped hover
                                tableHeaderClass='mb-0'
                                remote
                                keyField="id"
                                data={listItems}
                                columns={columns}
                                pagination={paginationFactory({page, sizePerPage, totalSize})}
                                onTableChange={this.handleTableChange}
                            />
                    </CardBody>
                </Card>
            </div>
        )
    }
}

export default RolePermissionList;